<div class="main-table">
  <table class="table">
    <thead>
      <tr>
        <ng-container *ngFor="let tableColumn of tableColumns">
          <th [class.custom-bg-th]="tableColumn.border">
            <span class="header_label">
              {{ tableColumn?.columnName | translate }}
              <span class="text-transform-normal">
                {{ tableColumn?.symbol | reportDataValueType : current_lang }}
              </span>
            </span>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of tableData" [ngClass]="{ hideTable: showLoader }"
        [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor">
        <td>{{ element?.unit_size ?? '-' }}</td>
        <td>{{ element?.all_floor ? (element.all_floor | number : '1.0-1') : '-' }}</td>
        <td>{{ element?.lower_ground ? (element.lower_ground | number : '1.0-1') : '-' }}</td>
        <td>{{ element?.ground ? (element.ground | number : '1.0-1') : '-' }}</td>
        <td>{{ element?.first_floor ? (element.first_floor | number : '1.0-1') : '-' }}</td>
        <td>{{ element?.second_floor ? (element.second_floor | number : '1.0-1') : '-' }}</td>
        <td>{{ element?.third_floor ? (element.third_floor | number : '1.0-1') : '-' }}</td>
        <td>{{ element?.higher_floor ? (element.higher_floor | number : '1.0-1') : '-' }}</td>
      </tr>

      <tr *ngIf="showLoader" style="height: auto;">
        <td [attr.colspan]="tableColumns.length">
          <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
        </td>
      </tr>
    </tbody>
  </table>
</div>
